var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classNames},[_c('FontAwesomeIcon',{attrs:{"size":_vm.iconSize,"icon":"jw-crown-icon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }